import { render, staticRenderFns } from "./OrderItemDialog.vue?vue&type=template&id=cd4e9b32"
import script from "./OrderItemDialog.vue?vue&type=script&lang=js"
export * from "./OrderItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports